import { createTheme } from '@mui/material/styles';

export const OSHURETheme = createTheme({
  palette: {
    primary: {
      main: '#3cb0fd',
      contrastText: '#ffffff',
    },
    secondary: {
      main: 'rgb(141, 198, 63)',
    },
    background: {
      default: '#ffffff',
    },
  },
  components: {
    MuiButton: {
      styleOverrides: {
        root: {
          borderRadius: '25px',
        },
        containedPrimary: {
          color: 'white',
        },
        containedSecondary: {
          color: 'white',
        },
      },
    },
    MuiDivider: {
      styleOverrides: {
        root: {
          color: 'black',
          backgroundColor: 'rgba(0, 0, 0, 0.2)',
          margin: '16px 0',
        },
      },
    },
    MuiImageListItem: {
      styleOverrides: {
        root: {
          borderRadius: '5px',
          overflow: 'hidden',
        },
      },
    },
    MuiAppBar: {
      styleOverrides: {
        colorPrimary: {
          background: 'linear-gradient(90deg, rgba(3, 102, 168, 1) 0%, rgba(60, 176, 253, 1) 100%)',
        },
      },
    },
    MuiAccordion: {
      styleOverrides: {
        rounded: {
          borderRadius: '5px',
        },
      },
    },
    MuiCssBaseline: {
      styleOverrides: {
        img: {
          borderRadius: '5px',
        },
      },
    },
  },
});
